import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {User} from "../models/User";
import {Response} from "../models/Response";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  /**
   * Autenticación de un usuario.
   *
   * @return Observable<Response<User>> Observable de la respuesta de la autenticación.
   */
  signIn(email: string, password: string, officeId?: number | null): Observable<Response<User>> {
    const body: any = {email: email, password: password};
    if (officeId != null) {
      body.office_id = officeId;
    }
    return this.http.post<Response<User>>(`${environment.API_URL}/auth/login`, body);
  }

  /**
   * Cambia la sucursal de trabajo de la sesión actual (sin re-login).
   */
  switchOffice(officeId: number): Observable<Response<{ active_office: any }>> {
    return this.http.post<Response<{ active_office: any }>>(`${environment.API_URL}/auth/office`, {office_id: officeId});
  }

  logOut(): Observable<Response<null>>{
    return this.http.post<Response<null>>(`${environment.API_URL}/auth/logout`, null);
  }

  sendPasswordResetLink(email: string): Observable<any> {
    return this.http.post(`${environment.API_URL}/auth/password/email`, { email });
  }

  resetPassword(data: { email: string, password: string, password_confirmation: string, token: string }): Observable<any> {
    return this.http.post(`${environment.API_URL}/auth/password/reset`, data);
  }

  /*profile(): Observable<Response<User>>  {
    return this.http.get<Response<User>>(`${environment.API_URL}/auth/profile`);
  }*/
}
